import React, { useEffect, useState } from "react";
import GroupAdminHeader from "../../../../Comman/Header";
import api from "../../../../../CommonApi/axios";
import GroupAdminUperSide from "../../../../Comman/UperSide";
import GroupAdminSidebar from "../../../../Comman/Sidebar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import { useMediaQuery } from "react-responsive";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import headers from "../../../../../CommonApi/headers";
// import BarChart from "./Chart/BarChart";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Box, Typography } from "@mui/material";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from '@mui/material/Backdrop';
import useDrawer from "../../../../../context/DrawerContext";
import { ErrorMessage } from "../../../../Comman/Error/ErrorMessage";
import useError from "../../../../Comman/Error/useError";
import { getCurrencyLabel } from "../../../../Comman/currencyUtils/currencyUtils";
import { selectStylesReport } from "../../../../Comman/CommonFunction/CommonFunction";
import { connect } from "react-redux";
import { getBranchList } from "../../../../../Store";
import { branchfilterAndMapData, getSelectOptions } from "../../../../Comman/BranchList";
// import { setMaxDate } from "../../../../Comman/DateUtils/dateUtils";
import * as XLSX from 'xlsx';
// import capitalizeFirstLetter from "../../../../Comman/UpperCase";
// import BranchCharts from "./Chart/BarChart";
import { exportPDFforReservationReport, exportXlsxReservationForReport } from "./ReportCommon/ReportCommon";
// import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Bar, BarChart } from 'recharts';
import { PieChart, Pie, Cell, Tooltip, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

import { format, startOfWeek, startOfMonth, startOfYear } from 'date-fns';




function GroupAdminTableReservations({ getBranchList, BranchList_ }) {

      const { error, showError, clearError } = useError();

      const errorDiv = error ? (
        <div className="text-center alert alert-danger">{error}</div>
      ) : (
        ""
      );

      let history = useHistory();
      const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
      const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
      const filteredOptions = branchfilterAndMapData(BranchList_);


      const [start_date, setstart_date] = useState("");
      const [end_date, setend_date] = useState(new Date());
      const [is_present, setis_present] = useState(false);
      const [branch_id, setbranch_id] = useState("");
      const [branch_id2, setbranch_id2] = useState([]);
      const [Reservation_type, setReservation_type] = useState("");
      const [Reservation_type2, setReservation_type2] = useState([]);
      const [Request_type, setRequest_type] = useState("");
      const [Request_type2, setRequest_type2] = useState([]);
      const [loader, setLoader] = useState(false);
      const [CSVDATA, setCSVDATA] = useState([]);
      // const [error, setError] = useState([]);
      const [Dowloader, setDowloader] = useState(false);
      const [PDFLogo, setPDFLogo] = useState("");
      const [DataReport, setDataReport] = useState([]);
      const [pieChartData, setPieChartData] = useState([]);
      const [barChartData, setBarChartData] = useState([]);
      const [pieChartData2, setPieChartData2] = useState([]);
      // const [requestTypes, setRequestTypes] = useState([]);
      const [summaryCounts, setSummaryCounts] = useState({
        accepted: 0,
        guestArrived: 0,
        pending: 0,
        canceled: 0,
      });

      const [hoveredBar, setHoveredBar] = useState(null);

      const CustomTooltip = ({ active, payload }) => {
        if (!active || !payload || !hoveredBar) return null;
      
        const hoveredPayload = payload.find(p => p.dataKey === hoveredBar);
      
        if (!hoveredPayload) return null;
      
        const { name, value, fill } = hoveredPayload;
      
        return (
          <div
            style={{
              background: 'white',
              padding: '10px',
              border: `2px solid ${fill || '#ccc'}`,
              borderRadius: '10px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              color: '#000',
              fontFamily: 'inherit',
            }}
          >
            <p style={{ margin: 0, fontWeight: 600, fontSize: '14px' }}>
              {name?.split(' ')[0] || 'Meal'}
            </p>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: fill || '#ccc',
                  display: 'inline-block',
                  marginRight: 6,
                }}
              ></span>
              <span style={{ fontSize: '13px' }}>
                {name?.split(' ').slice(1).join(' ') || 'Type'}:{' '}
                <span style={{ fontWeight: 700 }}>{value}</span>
              </span>
            </div>
          </div>
        );
      };
      

      const CustomPieTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
          const entry = payload[0];
          return (
            <div
              style={{
                background: 'white',
                border: `2px solid ${entry.payload.fill}`,
                padding: 10,
                borderRadius: 10,
                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
              }}
            >
              <p style={{ fontWeight: 600, marginBottom: 5 }}>{entry.name}</p>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: entry.payload.fill,
                    display: 'inline-block',
                    marginRight: 6,
                  }}
                ></span>
                <span style={{ fontWeight: 400 }}>Reservations:</span>
                <span style={{ fontWeight: 700, marginLeft: 4 }}>{entry.value}</span>
              </div>
            </div>
          );
        }
      
        return null;
      };
      
      const CustomBarTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          const data = payload[0];
          const [meal, type] = data.name.split(' ');
          return (
            <div
              style={{
                background: 'white',
                border: `2px solid ${data.fill}`,
                padding: 10,
                borderRadius: 10,
                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
              }}
            >
              <p style={{ fontWeight: 600, marginBottom: 5 }}>{meal}</p>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: data.fill,
                    display: 'inline-block',
                    marginRight: 6,
                  }}
                ></span>
                <span style={{ fontWeight: 400 }}>{type}:</span>
                <span style={{ fontWeight: 700, marginLeft: 4 }}>{data.value}</span>
              </div>
            </div>
          );
        }
      
        return null;
      };
      

      const statusColorMap = {
        accepted: '#2D99FE',
        canceled: '#6F58E9',
        guestArrived: '#2DDAC1',
        pending: '#94D13D'
      };

      const barChartData2 = [
        { date: '01-04-2025', Customer: 90, WalkIn: 35, ByCall: 70 },
        { date: '02-04-2025', Customer: 95, WalkIn: 65, ByCall: 40 },
        { date: '03-04-2025', Customer: 50, WalkIn: 35, ByCall: 30 },
        { date: '04-04-2025', Customer: 85, WalkIn: 45, ByCall: 55 },
        { date: '05-04-2025', Customer: 95, WalkIn: 30, ByCall: 90 },
        { date: '06-04-2025', Customer: 70, WalkIn: 25, ByCall: 15 },
        { date: '07-04-2025', Customer: 90, WalkIn: 75, ByCall: 60 },
      ];

      const colorMap = {
        'customer-dinner': '#4D96FF',      // Blue
        'customer-lunch': '#F7B801',       // Yellow
        'by-call-lunch': '#FF6B6B',        // Red
        'by-call-dinner': '#FF9671',       // Orange
        'walk-in-lunch': '#9D4EDD',        // Purple
        'walk-in-dinner': '#D7BAFF',       // Light Purple
      };
          
      const meals = ['lunch', 'dinner'];
      const requestTypes = ['walk-in', 'by-call', 'customer'];

      const colorMap2 = {
        "walk-in": '#845EC2',
        "by-call": '#F9A1BC',
        "customer": '#6BCB77'
      };

      const labelMap = {
        'customer-dinner': 'Customer - Dinner',
        'customer-lunch': 'Customer - Lunch',
        'by-call-lunch': 'By Call - Lunch',
        'by-call-dinner': 'By Call - Dinner',
        'walk-in-lunch': 'Walk in - Lunch',
        'walk-in-dinner': 'Walk in - Dinner',
      };

      const renderCustomLabel = ({ percent, x, y }) => (
        <text
          x={x}
          y={y}
          fill="black"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={12}
          fontWeight="bold"
        >
          {(percent * 100).toFixed(1)}%
        </text>
      );
      

    
      const getXAxisType = (startDate, endDate) => {
        const diffInDays = (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);
        
        if (diffInDays <= 7) return 'day';
        if (diffInDays <= 31) return 'week';
        if (diffInDays <= 365) return 'month';
        return 'year';
      };
      
      const getFormattedDateKey = (date, granularity) => {
        const d = new Date(date);
        console.log("...................####################################")
        switch (granularity) {
          case 'day':
            return format(d, 'yyyy-MM-dd');
          case 'week':
            return format(startOfWeek(d, { weekStartsOn: 1 }), 'yyyy-MM-dd');
          case 'month':
            return format(startOfMonth(d), 'yyyy-MM');
          case 'year':
            return format(startOfYear(d), 'yyyy');
          default:
            return format(d, 'yyyy-MM-dd');
        }
      };

      useEffect(() => {
            getBranchList();
            //  setMaxDate(["date", "date1"]); //// Max date validation ////
      }, []);
      

     

      function handleSubmit(event) {
            event.preventDefault();
            clearError(null);
            setDataReport([]);

            // Validate required fields
            if (!branch_id) {
                  showError("Please select branch.");
                  return;
            }
            if (!Reservation_type) {
              showError("Please select reservation type.");
              return;
            }
            if (!Request_type) {
                  showError("Please select request type.");
                  return;
            }
            if (!start_date) {
                  showError("Please select start date.");
                  return;
            }

            // Check date logic
            const endDateFormatted = moment(end_date).add(1, "days").format("YYYY-MM-DD");
            const startDateFormatted = moment(start_date).format("YYYY-MM-DD");

            if (Date.parse(end_date) && Date.parse(endDateFormatted) <= Date.parse(start_date)) {
                  showError("End date should be greater than Start date");
                  return;
            }

            setLoader(true);
            let url = `/groupadmin/report/tableReservation?start_date=${startDateFormatted}`
            if(branch_id !== "All"){
                  url += `&branch_id=${branch_id}`;
            }

            if(Request_type !== "All"){
                  url += `&request_type=${Request_type}`;
            }

            if(Reservation_type !== "All"){
                  url += `&booking_type=${Reservation_type}`;
            }
            if(end_date){
              url += `&end_date=${endDateFormatted}`;
            }
            // Define the basePath dynamically based on Order_type
            api.get(url, { headers })
                  .then((res) => {
                  const tableData = res.data.data
                  // const branchesWithOrders = tableData.filter(branch => branch?.reservations?.length > 0);
                  // console.log(res.data.data);
                  setLoader(false);
                  setCSVDATA(tableData)
                  if (tableData?.length === 0) {
                        showError("No reservation data found.");
                  }
                  console.log(CSVDATA)
                  const chartDataMap= {}
                  let summaryCountsTemp = {
                    accepted: 0,
                    canceled: 0,
                    guestArrived: 0,
                    pending: 0,
                  };
                  let barChartDataMap = {}
                  const requestTypesSet = new Set();
                  const xAxisType = getXAxisType(start_date, end_date);

                  tableData.forEach(branch => {
                        branch.reservations.forEach(res => {
                          // const rawDate = res.booking_date;
                          let requestType = res.booking_request_type.toLowerCase(); // "customer", "by-call", "walk-in"
                          const bookingType = res.booking_type.toLowerCase(); // "lunch", "dinner"
                          const key = `${requestType}-${bookingType}`;
                          
                          const date = new Date(res.booking_date); // adjust key if needed
                          const xKey = getFormattedDateKey(date, xAxisType);
                          // const dateKey = date.toLocaleDateString('en-GB').split('/').reverse().join('-'); // 'dd-MM-yyyy'
                          const barKey = `${bookingType}_${requestType}`; // e.g., "lunch_walk_in"

                          requestTypesSet.add(barKey);

                          const status = res.status?.toLowerCase(); // "completed", "canceled", "guest arrived", "pending"
                          if (status === 'accepted') summaryCountsTemp.accepted++;
                          else if (status === 'cancelled') summaryCountsTemp.canceled++;
                          else if (status === 'guests arrived') summaryCountsTemp.guestArrived++;
                          else if (status === 'pending') summaryCountsTemp.pending++;
                          if (!chartDataMap[key]) chartDataMap[key] = 0;
                          chartDataMap[key]++;
                          
                          if (!barChartDataMap[xKey]) {
                            barChartDataMap[xKey] = { date: xKey };
                          }
                      
                          // if (!barChartDataMap[dateKey][barKey]) {
                          //   barChartDataMap[dateKey][barKey] = 0;
                          // }
                          barChartDataMap[xKey][barKey] = (barChartDataMap[xKey][barKey] || 0) + 1;

                          // barChartDataMap[dateKey][barKey]++;
                          console.log("........................///????????")
                        });
                        // });
                      });

                      const barChartDataTemp = Object.values(barChartDataMap).sort((a, b) => {
                        const d1 = new Date(a.date.split('-').reverse().join('-'));
                        const d2 = new Date(b.date.split('-').reverse().join('-'));
                        return d1 - d2;
                      });

                      console.log(barChartDataTemp,".................bar chart data")
                      console.log(chartDataMap,"...................chart data ")
                      console.log(summaryCountsTemp,"....................summary count")
                      // setRequestTypes(Array.from(requestTypesSet)); // <- optional if dynamically rendering Bars
                      setBarChartData(barChartDataTemp);
                      setSummaryCounts(summaryCountsTemp);
                      setPieChartData(Object.entries(chartDataMap).map(([key, value]) => ({
                        name: labelMap[key],
                        value,
                        fill: colorMap[key],
                      })));

                      setPieChartData2(Object.entries(summaryCountsTemp)
                      .filter(([_, value]) => value > 0)
                      .map(([key, value]) => ({
                        name: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()), // e.g., "guestArrived" → "Guest Arrived"
                        value,
                        fill: statusColorMap[key]
                      })));


                    console.log(barChartData,"......bar chart data")
                  })
                  .catch((err) => {
                  setLoader(false);
                  if (err.response) {
                    showError(err.response?.data?.error?.message);
                  }
            });
      }


      useEffect(()=>{
      },[pieChartData,CSVDATA,summaryCounts, barChartData, requestTypes, pieChartData2])
      const { drawerPos, handleDrawer, mainClassCustome } = useDrawer();


      

      // return (
      //       <React.Fragment>
      //             <div
      //                   id="kt_body"
      //                   className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
      //             >
      //                   <div className="d-flex flex-column flex-root">
      //                         <div className="page d-flex flex-row flex-column-fluid">
      //                               <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
      //                               <div
      //                                     className="wrapper d-flex flex-column flex-row-fluid"
      //                                     id="kt_wrapper"
      //                               >
      //                                     <GroupAdminHeader />

      //                                     <div
      //                                           className=" d-flex flex-column flex-column-fluid"
      //                                           id="kt_content"
      //                                     >
      //                                           <div id="kt_content_container" className={isMobile ? "mx-5 p-0" : "mx-7 p-0"} >
      //                                                 <main style={{ position: "initial" }} className={mainClassCustome.join(" ")}>

      //                                                       <div className="d-flex flex-stack mb-2 p-0">
      //                                                             <div
      //                                                                   className="d-flex justify-content-end"
      //                                                                   data-kt-docs-table-toolbar="base"
      //                                                             >
      //                                                                   <h2
      //                                                                         className="anchor fw-bolder mb-5"
      //                                                                         id="custom-form-control"
      //                                                                   >
      //                                                                         Table Reservation Reports
      //                                                                   </h2>
      //                                                             </div>
      //                                                             <div className="d-flex flex-stack mb-5">
      //                                                                   <div
      //                                                                         className="d-flex justify-content-end mx-2"
      //                                                                         data-kt-docs-table-toolbar="base"
      //                                                                   >
      //                                                                         <button
      //                                                                               onClick={() => history.push("/group_admin/report")}
      //                                                                               className="btn btn-primary ps-7"
      //                                                                         >
      //                                                                               Go Back
      //                                                                         </button>
      //                                                                   </div>
      //                                                             </div>
      //                                                       </div>

      //                                                       <div className="py-2">
      //                                                             <Card style={{ border: "1px solid #bdbcbc" }}>
      //                                                                   <Card.Body>
      //                                                                         <Row >
      //                                                                               <Col lg={2} md={2} sx={2}>
      //                                                                                     <label className="required form-label">
      //                                                                                           Select Branch
      //                                                                                     </label>
      //                                                                                     <Select
      //                                                                                           styles={selectStylesReport}
      //                                                                                           className="search-line"
      //                                                                                           placeholder="Search..."
      //                                                                                           options={getSelectOptions(filteredOptions)}
      //                                                                                           value={branch_id2}
      //                                                                                           onChange={(opt) => {
      //                                                                                                 if (opt.value === "All") {
      //                                                                                                       setbranch_id(opt.value);
      //                                                                                                 } else {
      //                                                                                                       setbranch_id(opt.value?.value);
      //                                                                                                 }
      //                                                                                                 setbranch_id2(opt);
      //                                                                                                 setDataReport([]);
      //                                                                                                 setis_present(false);
      //                                                                                           }}
      //                                                                                     />
      //                                                                               </Col>

      //                                                                               <Col lg={2} md={2} sx={2}>
      //                                                                                     <label className="required form-label">
      //                                                                                           Select Request Type
      //                                                                                     </label>
      //                                                                                     <Select
      //                                                                                           styles={selectStylesReport}
      //                                                                                           className="search-line"
      //                                                                                           placeholder="Search..."
      //                                                                                           options={[
      //                                                                                                 {
      //                                                                                                       label: "All",
      //                                                                                                       value: "All",
      //                                                                                                 },
      //                                                                                                 {
      //                                                                                                       label: "Website",
      //                                                                                                       value: "Website",
      //                                                                                                 },
      //                                                                                                 {
      //                                                                                                       label: "By Call",
      //                                                                                                       value: "By Call",
      //                                                                                                 },
      //                                                                                                 {
      //                                                                                                       label: "Walk-in",
      //                                                                                                       value: "Walk-in",
      //                                                                                                 },


      //                                                                                           ]}
      //                                                                                           value={Request_type2}
      //                                                                                           onChange={(opt) => {
      //                                                                                                 setDataReport([]);
      //                                                                                                 if (opt.value === "All") {
      //                                                                                                       setRequest_type(opt.value);
      //                                                                                                 } else {
      //                                                                                                       setRequest_type(opt.value?.value);
      //                                                                                                 }
      //                                                                                                 setRequest_type(opt.value);
      //                                                                                                 setRequest_type2(opt);
      //                                                                                                 setis_present(false);
      //                                                                                           }}
      //                                                                                     /></Col>

      //                                                                               <Col lg={2} md={2} sx={2}>
      //                                                                                     <label className="required form-label">
      //                                                                                           Select Reservation Type
      //                                                                                     </label>
      //                                                                                     <Select
      //                                                                                           styles={selectStylesReport}
      //                                                                                           className="search-line"
      //                                                                                           placeholder="Search..."
      //                                                                                           options={[
      //                                                                                                 {
      //                                                                                                       label: "All",
      //                                                                                                       value: "All",
      //                                                                                                 },
      //                                                                                                 {
      //                                                                                                       label: "Lunch",
      //                                                                                                       value: "lunch",
      //                                                                                                 },
      //                                                                                                 {
      //                                                                                                       label: "Dinner",
      //                                                                                                       value: "dinner",
      //                                                                                                 },
                                                                  
      //                                                                                           ]}
      //                                                                                           value={Reservation_type2}
      //                                                                                           onChange={(opt) => {
      //                                                                                                 setDataReport([]);
      //                                                                                                 setReservation_type(opt.value);
      //                                                                                                 setReservation_type2(opt);
      //                                                                                                 setis_present(false);
      //                                                                                           }}
      //                                                                                     /></Col>

      //                                                                               <Col lg={2} md={2} sx={2}>
      //                                                                                     <label className="required form-label">
      //                                                                                           Start Date
      //                                                                                     </label>
      //                                                                                     <input
      //                                                                                           type="date"
      //                                                                                           name="date"
      //                                                                                           id="date"
      //                                                                                           className="form-control"
      //                                                                                           value={start_date}
      //                                                                                           onChange={(e) => {
      //                                                                                                 setstart_date(e.target.value);
      //                                                                                                 setDataReport([]);
      //                                                                                           }}
      //                                                                                     />
      //                                                                               </Col>
      //                                                                               <Col lg={2} md={2} sx={2}>
      //                                                                                     <label className="form-label">End Date</label>
      //                                                                                     <input
      //                                                                                           type="date"
      //                                                                                           name="date1"
      //                                                                                           id="date1"
      //                                                                                           className="form-control"
      //                                                                                           value={end_date}
      //                                                                                           onChange={(e) => {
      //                                                                                                 setend_date(e.target.value);
      //                                                                                                 setDataReport([]);
      //                                                                                           }}
      //                                                                                     />
      //                                                                               </Col>

      //                                                                         </Row>

      //                                                                         <div className="row mt-7" >


      //                                                                               <div className={isTabletOrMobile ? "col-md-4 mt-8 text-end" : "col-md-3 mt-8"} >
      //                                                                                     {loader ? (
      //                                                                                           <Box>
      //                                                                                                 <CircularProgress />
      //                                                                                           </Box>
      //                                                                                     ) : (
      //                                                                                           <button
      //                                                                                                 onClick={(e) => handleSubmit(e)}
      //                                                                                                 type="button"
      //                                                                                                 className="btn btn-secondary"
      //                                                                                           >
      //                                                                                                 <span className="indicator-label">
      //                                                                                                       <i className="fa fa-eye fs-2"></i>&nbsp;
      //                                                                                                       Preview</span>
      //                                                                                           </button>
      //                                                                                     )}
  
      //                                                                               </div>
      //                                                                               <div className={isTabletOrMobile ? "col-md-12 mt-8 text-end" : "col-md-5 mt-9 text-end"}>
      //                                                                                     {/* {CSVDATA?.length > 0 &&
      //                                                                                           <React.Fragment>
      //                                                                                                 {Dowloader ?
      //                                                                                                       <Backdrop
      //                                                                                                             sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      //                                                                                                             open={true}
      //                                                                                                       >
      //                                                                                                             <CircularProgress color="inherit" />
      //                                                                                                       </Backdrop> :
      //                                                                                                       <button
      //                                                                                                             onClick={handleConvertToPdf}
      //                                                                                                             type="button"
      //                                                                                                             className="btn btn-secondary"
      //                                                                                                       >
      //                                                                                                             <span className="indicator-label">
      //                                                                                                                   <i className="fa fa-file-pdf-o fs-3"></i>&nbsp;Download PDF</span>
      //                                                                                                       </button>}
      //                                                                                                 &nbsp;&nbsp;
      //                                                                                                 <button
      //                                                                                                       onClick={handleConvertToPdf}
      //                                                                                                       type="button"
      //                                                                                                       className="btn btn-secondary"
      //                                                                                                 >
      //                                                                                                       <span className="indicator-label">

      //                                                                                                             <i className="fa fa-file-excel-o fs-3"></i>&nbsp;Download XLSX</span>
      //                                                                                                 </button>
      //                                                                                           </React.Fragment>} */}
      //                                                                                           {CSVDATA?.length > 0 &&
      //                                                                                           <div className="row col-md-12 mt-6">
      //                                                                                           <div className="col-md-4"></div>
      //                                                                                           <div className="col-md-4"></div>
                                                            
      //                                                                                           <div className="col-md-4 text-end">
      //                                                                                           <button
      //                                                                                                 type="button"
      //                                                                                                 onClick={() => exportPDFforReservationReport(CSVDATA, start_date, end_date)}
      //                                                                                                 className="btn btn-success mx-3"
      //                                                                                           >
      //                                                                                                 Download PDF
      //                                                                                           </button>
                                                            
      //                                                                                           <button
      //                                                                                                 type="button"
      //                                                                                                 onClick={() => exportXlsxReservationForReport(CSVDATA, start_date, end_date)}
      //                                                                                                 className="btn btn-success"
      //                                                                                           >
      //                                                                                                 <span className="indicator-label">
      //                                                                                                 Download XLSX
      //                                                                                                 </span>
      //                                                                                           </button>
      //                                                                                           </div>
      //                                                                                           </div>}
      //                                                                               </div>
      //                                                                         </div>
      //                                                                         <br />
      //                                                                         <ErrorMessage error={error} />
                                                                  
      //                                                             <PieComponent data={pieChartData} />
      //                                                                   </Card.Body>
      //                                                             </Card>

      //                                                             {/* <div>
      //                     <div id="contentToConvert" >
      //                       {Order_type === "Best selling products by orders" &&
      //                         <BranchCharts currencyLabel={currencyLabel} data={DataReport} />
      //                       }
      //                     </div>
      //                   </div> */}

      //                                                             {is_present &&
      //                                                                   <Card style={{ border: "1px solid rgb(189, 188, 188)" }} className="mt-10 my-4 text-center">
      //                                                                         <Row className="my-5 text-center">
      //                                                                               <Col className="my-4">
      //                                                                                     <h5>
      //                                                                                           No Data for the selected Date or Filter. Please select a different Date or Filter.
      //                                                                                     </h5>
      //                                                                               </Col>
      //                                                                         </Row>
      //                                                                   </Card>}

      //                                                       </div>
      //                                                 </main>
      //                                           </div>
      //                                     </div>
      //                               </div>
      //                         </div>
      //                         <GroupAdminUperSide />
      //                   </div>
      //             </div>

      //             <ToastContainer />
      //       </React.Fragment>
      // );

      return (
          <React.Fragment>
            <div
              id="kt_body"
              className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
            >
              <div className="d-flex flex-column flex-root">
                <div className="page d-flex flex-row flex-column-fluid">
                  <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
                  <div
                    className="wrapper d-flex flex-column flex-row-fluid"
                    id="kt_wrapper"
                  >
                    <GroupAdminHeader />
      
                    <div
                      className=" d-flex flex-column flex-column-fluid"
                      id="kt_content"
                    >
                      <div id="kt_content_container" className="mx-7 p-0">
                        <main style={{ position: "initial" }} className={mainClassCustome.join(" ")}>
                          <div className="d-flex flex-stack mb-2">
                            <div
                              className="d-flex justify-content-end p-0"
                              data-kt-docs-table-toolbar="base"
                            >
                              <h2
                                className="anchor fw-bolder mb-5"
                                id="custom-form-control"
                              >
                                Table Reservation Reports
                              </h2>
                            </div>
                            <div className="d-flex flex-stack mb-5">
                              <div
                                className="d-flex justify-content-end mx-2"
                                data-kt-docs-table-toolbar="base"
                              >
                                <button
                                  onClick={() => history.push("/group_admin/report")}
                                  className="btn btn-primary ps-7"
                                >
                                  Go Back
                                </button>
                              </div>
                            </div>
                          </div>
      
                          <div className="py-2">
                            <form onSubmit={handleSubmit}>
                              <div className="card card-docs">
                                <div
                                  className={
                                    isMobile
                                      ? "card-body fs-6 py-15 px-3 py-lg-15  text-gray-700"
                                      : "card-body fs-6 py-15 px-10 py-lg-15 px-lg-15 text-gray-700"
                                  }
                                >
                                  <div
                                    className={isMobile ? "" : "rounded border p-10"}
                                  >
                                    <div className="row">
                                      
                                      <div className="col-md-3">
                                        <label className="required form-label">
                                          Select Branch
                                        </label>
                                        {/* <BranchListDropDown onBranchChange={handleBranchChange}/> */}
                                        <Select
                                          styles={selectStylesReport}
                                          className="search-line"
                                          placeholder="Search..."
                                          // options={[
                                          //   {
                                          //     label: "All",
                                          //     value: "all",
                                          //   },
                                          //   ...filteredOptions,
                                          // ]}
      
                                          options={getSelectOptions(filteredOptions)}
                                          value={branch_id2}
                                          onChange={(opt) => {
                                            if(opt.value === "All"){
                                              setbranch_id(opt.value);
                                            }else{
                                              setbranch_id(opt.value?.value);
                                            }
                                            setbranch_id2(opt);
                                          }}
                                        />
                                      </div>
      
                                      
                                      
                                      <div className="col-md-3">
                                        <label className="required form-label">
                                          Select Reservation Type
                                        </label>
                                        <Select
      
                                          styles={selectStylesReport}
                                          className="search-line"
                                          placeholder="Search..."
                                          options={[
                                            {
                                                  label: "All",
                                                  value: "All",
                                            },
                                            {
                                                  label: "Lunch",
                                                  value: "lunch",
                                            },
                                            {
                                                  label: "Dinner",
                                                  value: "dinner",
                                            },
        
                                      ]}
                                      value={Reservation_type2}
                                      onChange={(opt) => {
                                            setDataReport([]);
                                            setReservation_type(opt.value);
                                            setReservation_type2(opt);
                                            setis_present(false);
                                      }}
                                        />
                                      </div>
                                      <div className="col-md-2">
                                        <label className="form-label">
                                          Select Request type
                                        </label>
                                        <Select
                                          styles={selectStylesReport}
                                          className="search-line"
                                          placeholder="Search..."
                                          options={[
                                            {
                                                  label: "All",
                                                  value: "All",
                                            },
                                            {
                                                  label: "Website",
                                                  value: "Website",
                                            },
                                            {
                                                  label: "By Call",
                                                  value: "By Call",
                                            },
                                            {
                                                  label: "Walk-in",
                                                  value: "Walk-in",
                                            },
                                      ]}
                                          value={Request_type2}
                                          onChange={(opt) => {
                                            setDataReport([]);
                                            if (opt.value === "All") {
                                                  setRequest_type(opt.value);
                                            } else {
                                                  setRequest_type(opt.value?.value);
                                            }
                                            setRequest_type(opt.value);
                                            setRequest_type2(opt);
                                            setis_present(false);
                                          }}
                                        />
                                      </div>
                                      <div className="col-md-2">
                                        <label className="required form-label">
                                          Start Date
                                        </label>
                                        <input
                                          type="date"
                                          name="date"
                                          id="date"
                                          className="form-control"
                                          value={start_date}
                                          onChange={(e) => {
                                            setstart_date(e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="col-md-2">
                                        <label className="form-label">End Date</label>
                                        <input
                                          type="date"
                                          name="date1"
                                          id="date1"
                                          className="form-control"
                                          value={end_date}
                                          onChange={(e) => {
                                            setend_date(e.target.value);
                                          }}
                                        />
                                      </div>
                                          
                                      {CSVDATA?.length > 0 &&
                                      <div className="row col-md-12 mt-6">
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4"></div>
      
                                        <div className="col-md-4 text-end">
                                          <button
                                            type="button"
                                            onClick={() => exportPDFforReservationReport(CSVDATA, start_date, end_date)}
                                            className="btn btn-success mx-3"
                                          >
                                            Download PDF
                                          </button>
      
                                          <button
                                            type="button"
                                            onClick={() => exportXlsxReservationForReport(CSVDATA, start_date, end_date)}
                                            className="btn btn-success"
                                          >
                                            <span className="indicator-label">
                                              Download XLSX
                                            </span>
                                          </button>
                                        </div>
                                      </div>}   
                                      <div className="row col-md-12 text-center mt-5">
                                        {loader ? (
                                          <Box>
                                            <CircularProgress />
                                          </Box>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      <div className="col-md-12 my-3"> {errorDiv} </div>
                                      <div className="col-md-4"></div>
                                      <div className="col-md-4 text-center mt-3">
                                        <button
      
                                          type="submit"
                                          className="btn btn-primary"
                                        >
                                          Submit
                                        </button>
                                        {/* <button
                                        type="button"
                                        onClick={() => {
                                          setend_date("");
                                          setstart_date("");
                                          setbranch_id("");
                                          setbranch_id2([]);
                                          setError(null);
                                          setOrder_type("");
                                          setOrder_type2([]);
                                        }}
                                        className="btn btn-danger mx-2"
                                      >
                                        Cancel
                                      </button> */}
                                      </div>
                                      <div className="col-md-4"></div>
                                    </div>

                                    <hr className="mt-9" />
      
                                    {/* {CSVDATA?.length > 0 &&
                                      <div className="row col-md-12 mt-6">
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4"></div>
      
                                        <div className="col-md-4 text-end">
                                        <button
                                        type="button"
                                        onClick={() => exportPDFforReservationReport(CSVDATA, start_date, end_date)}
                                            className="btn btn-success mx-3"
                                          >
                                            Download PDF
                                          </button>
      
                                          <button
                                            type="button"
                                            onClick={() => exportXlsxReservationForReport(CSVDATA, start_date, end_date)}
                                            className="btn btn-success"
                                          >
                                          <span className="indicator-label">
                                          Download XLSX
                                          </span>
                                          </button>
                                          </div>
                                          </div>} */}

                                        {/* <Card className="mb-5">
                                                    <Card.Body>
                                                      <h4 className="mb-4">Summary Chart</h4>
                                                      
                                                      <Row>
                                                        <Col md={8}>
                                                          <div style={{ width: '100%', height: 400 }}>
                                                            <ResponsiveContainer>
                                                              <PieChart>
                                                                <Pie
                                                                  data={pieChartData}
                                                                  cx="50%"
                                                                  cy="50%"
                                                                  outerRadius={130}
                                                                  dataKey="value"
                                                                  labelLine={false}
                                                                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`}
                                                                >
                                                                  {pieChartData.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={entry.fill} />
                                                                  ))}
                                                                </Pie>
                                                                <Tooltip formatter={(value) => [`${value}`, 'Reservations']} />
                                                                <Legend />
                                                              </PieChart>
                                                            </ResponsiveContainer>
                                                          </div>
                                                        </Col>
                                                        
                                                        <Col md={4} className="d-flex align-items-center">
                                                        <ul className="list-unstyled mt-3">
                                                          <li className="mb-3">
                                                            <span className="fw-bold">• Total Successfully Completed Reservations:</span> {summaryCounts.completed}
                                                          </li>
                                                          <li className="mb-3">
                                                            <span className="fw-bold">• Total Guest Non-Arrival Reservations:</span> {summaryCounts.guestArrived}
                                                          </li>
                                                          <li className="mb-3">
                                                            <span className="fw-bold">• Total Pending Reservations:</span> {summaryCounts.pending}
                                                          </li>
                                                          <li className="mb-3">
                                                            <span className="fw-bold">• Total Cancelled Reservations:</span> {summaryCounts.canceled}
                                                          </li>
                                                        </ul>
                                                      </Col>

                                                      </Row>
                                                    </Card.Body>
                                                  </Card> */}
                                                  {console.log(pieChartData,".......pie chart data")}
                                                  {console.log(pieChartData2,".......pie chart data 2")}
                                                  {console.log(barChartData,".......bar chart data ")}
                                                  {CSVDATA.length > 0 && (
                                                  <Card className="mb-5">
                                                    <Card.Body>
                                                      <h4 className="mb-4">Summary Chart</h4>

                                                      <Row>
                                                        <Col md={8}>
                                                          <div style={{ width: '100%', height: 400 }}>
                                                            <ResponsiveContainer>
                                                            <PieChart onClick={(e) => e?.stopPropagation()}>
                                                            <Pie
                                                                  data={pieChartData}
                                                                  cx="50%"
                                                                  cy="50%"
                                                                  outerRadius={130}
                                                                  dataKey="value"
                                                                  labelLine={false}
                                                                  label={renderCustomLabel}
                                                                  onClick={() => {}}                                                                  >
                                                                  {pieChartData.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={entry.fill} />
                                                                  ))}
                                                                </Pie>
                                                                <Tooltip content = {<CustomPieTooltip />} />
                                                                <Legend
                                                                payload={pieChartData.map(entry => ({
                                                                  value: entry.name, // Use actual label from data
                                                                  type: 'circle', // Circle shape
                                                                  id: entry.name,
                                                                  color: entry.fill, // Correct color from your pieChartData
                                                                }))}
                                                                formatter={(value) => (
                                                                  <span style={{ color: 'black', marginLeft: 5 }}>{value}</span>
                                                                )}
                                                              />
                                                              </PieChart>
                                                            </ResponsiveContainer>
                                                          </div>
                                                        </Col>

                                                        <Col md={4} className="d-flex align-items-center">
                                                          <ul className="list-unstyled mt-3" style={{ paddingLeft: '0' }}>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px' }}>
                                                              • Total Successfully Completed Reservations: {summaryCounts.guestArrived}
                                                            </li>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px' }}>
                                                              • Total Guest Non-Arrival Reservations: {summaryCounts.accepted}
                                                            </li>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px'}}>
                                                              • Total Pending Reservations: {summaryCounts.pending}
                                                            </li>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px' }}>
                                                              • Total Cancelled Reservations: {summaryCounts.canceled}
                                                            </li>
                                                          </ul>
                                                        </Col>

                                                      </Row>
                                                    </Card.Body>
                                                    <hr className="mt-9" />
                                                  </Card>


                                                )}

                                                {CSVDATA.length > 0 && (
                                                  <Card className="mb-5">
                                                    <Card.Body>
                                                      <h4 className="text-lg font-medium mb-4">Detail Chart</h4>
                                                      <div style={{ width: '100%', height: 400 }}> {/* Explicit height */}
                                                      <ResponsiveContainer >
                                                      <BarChart data={barChartData}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="date" />
                                                        <YAxis />
                                                        <Tooltip
                                                          cursor={{ fill: 'transparent' }}
                                                          content= {<CustomTooltip />}/>
                                                        <Legend
                                                          layout="horizontal"
                                                          align="center"
                                                          verticalAlign="bottom"
                                                          wrapperStyle={{
                                                            marginTop: '20px',   // Space between graph and legend
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            gap: '24px',         // Space between Walk-In, By-Call, Customer
                                                          }}
                                                          payload={requestTypes.map(type => ({
                                                            value: type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                                                            type: 'circle',
                                                            id: type,
                                                            color: colorMap2[type],
                                                          }))}
                                                          formatter={(value) => (
                                                            <span style={{ color: 'black' }}>{value}</span>
                                                          )}
                                                        />
                                                        
                                                      {meals.map(meal =>
                                                        requestTypes.map(type => {
                                                          const dataKey = `${meal}_${type}`;
                                                          return (
                                                            <Bar
                                                              key={dataKey}
                                                              dataKey={dataKey}
                                                              stackId={meal}
                                                              fill={colorMap2[type]}
                                                              name={`${meal.charAt(0).toUpperCase() + meal.slice(1)} ${type.replace(/_/g, ' ')}`}
                                                              barSize={40}
                                                              onMouseOver={() => setHoveredBar(dataKey)}
                                                              onMouseLeave={() => setHoveredBar(null)}
                                                            />
                                                          );
                                                        })
                                                      )}
                                                      </BarChart>
                                                    </ResponsiveContainer>


                                                      </div>
                                                    </Card.Body>
                                                    <hr className="mt-9" />
                                                  </Card>
                                                )}

                                                {console.log(pieChartData2)}
                                                {CSVDATA.length > 0 && (
                                                  <Card className="mb-5">
                                                    <Card.Body>
                                                      <h4 className="mb-4">Status Chart</h4>

                                                      <Row>
                                                        <Col md={8}>
                                                          <div style={{ width: '100%', height: 400 }}>
                                                            <ResponsiveContainer>
                                                            <PieChart>
                                                            <Pie
                                                              data={pieChartData2}
                                                              cx="50%"
                                                              cy="50%"
                                                              outerRadius={130}
                                                              dataKey="value"
                                                              labelLine={false}
                                                              label={renderCustomLabel}
                                                            >
                                                              {pieChartData2.map((entry, index) => (
                                                                <Cell key={`cell-${index}`} fill={entry.fill} />
                                                              ))}
                                                            </Pie>
                                                            <Tooltip content={<CustomPieTooltip />} />
                                                            <Legend
                                                              payload={pieChartData2.map((entry, index) => ({
                                                                id: entry.name,
                                                                type: 'circle',            // circle shape
                                                                value: entry.name,          // label text
                                                                color: entry.fill,          // pie slice color
                                                              }))}
                                                              formatter={(value) => (
                                                                <span style={{ color: 'black', marginLeft: 6 }}>{value}</span> // text in black
                                                              )}
                                                            />
                                                          </PieChart>
                                                            </ResponsiveContainer>
                                                          </div>
                                                        </Col>

                                                        <Col md={4} className="d-flex align-items-center">
                                                          <ul className="list-unstyled mt-3">
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px'}}>
                                                              • Awaiting confirmation: {summaryCounts.pending}
                                                            </li>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px'}}>
                                                              • Guest not arrived yet: {summaryCounts.accepted}
                                                            </li>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px'}}>
                                                              • Completed reservations: {summaryCounts.guestArrived}
                                                            </li>
                                                            <li className="mb-3" style={{ fontWeight: 600, fontSize: '19.5px'}}>
                                                              • Cancelled reservations: {summaryCounts.canceled}
                                                            </li>
                                                          </ul>
                                                        </Col>
                                                      </Row>
                                                    </Card.Body>
                                                    <hr className="mt-9" />
                                                  </Card>


                                                )}
      

                                          {/* <PieComponent data={pieChartData} /> */}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </main>
                      </div>
                    </div>
                  </div>
                </div>
                <GroupAdminUperSide />
              </div>
            </div>
          </React.Fragment>
        );
}

const mapStateToProps = (state) => ({
      BranchList_: state.branchList,
});

const mapDispatchToProps = (dispatch) => {
      return {
            getBranchList: () => dispatch(getBranchList()),
      };
};
export default connect(mapStateToProps, mapDispatchToProps)(GroupAdminTableReservations);
